import { AuthBody } from 'models/AuthBody';
import cookieService, { COOKIE_KEYS } from 'services/cookieService';

export default {
  get token() {
    return cookieService.getItem<string>(COOKIE_KEYS.DR_TOKEN);
  },

  set token(token: string) {
    cookieService.setItem(COOKIE_KEYS.DR_TOKEN, token);
  },

  removeToken() {
    cookieService.removeItem(COOKIE_KEYS.DR_TOKEN);
  },

  saveAuthBody({ token }: Omit<AuthBody, 'user' | 'refreshToken'>) {
    this.token = token;
  },

  removeAuthBody() {
    this.removeToken();
  },
};
